import * as THREE from 'three';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js';
import { SSAOPass } from 'three/examples/jsm/postprocessing/SSAOPass.js';
import type { QualitySettings } from '../quality/QualitySettings';

export class PostFX {
  private composer: EffectComposer;
  private renderPass: RenderPass;
  private bloomPass?: UnrealBloomPass;
  private ssaoPass?: SSAOPass;
  private smaaPass?: SMAAPass;

  constructor(
    renderer: THREE.WebGLRenderer,
    scene: THREE.Scene,
    camera: THREE.Camera,
    quality: QualitySettings
  ) {
    this.composer = new EffectComposer(renderer);
    this.renderPass = new RenderPass(scene, camera);
    this.composer.addPass(this.renderPass);

    if (quality.postfx.bloom) {
      const bloom = new UnrealBloomPass(new THREE.Vector2(1, 1), 0.75, 0.25, 0.90);
      this.composer.addPass(bloom);
      this.bloomPass = bloom;
    }

    if (quality.postfx.ssao) {
      const ssao = new SSAOPass(scene, camera as any, 1, 1);
      ssao.kernelRadius = 14;
      ssao.minDistance = 0.005;
      ssao.maxDistance = 0.18;
      this.composer.addPass(ssao);
      this.ssaoPass = ssao;
    }

    if (quality.postfx.smaa) {
      const smaa = new SMAAPass();
      this.composer.addPass(smaa);
      this.smaaPass = smaa;
    }
  }

  setSize(w: number, h: number) {
    this.composer.setSize(w, h);
    this.bloomPass?.setSize(w, h);
    this.ssaoPass?.setSize(w, h);
    this.smaaPass?.setSize(w, h);
  }

  setBloom(strength: number, radius: number, threshold: number) {
    if (!this.bloomPass) return;
    this.bloomPass.strength = strength;
    this.bloomPass.radius = radius;
    this.bloomPass.threshold = threshold;
  }

  render(dt: number) {
    this.composer.render(dt);
  }
}
